import React from 'react';
import { useNavigate } from 'react-router-dom';
import userManager from '../../API/userManager';
import Api from '../../API/api';
import styled from 'styled-components';
import { Colors } from '../colors/colors';
import Icon from './Icon';

const { tokenManager } = Api;

const Wrapper = styled.div`
	width: 30px;
	height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
`;



const Logout = () => {
	const navigate = useNavigate();

	const handleLogout = () => {
		userManager.removeUser();
		tokenManager.removeToken();
		navigate('/login');
	};
	return (
		<Wrapper onClick={() => handleLogout()} className='animation-scale'>
			<Icon name='right-from-bracket' style={{ color: Colors.red, fontSize: 16 }} />
		</Wrapper>
	);
};

export default Logout;
